export interface Challenge {
  id: string;
  title?: string | null;
  description?: string | null;
  status?: string | null;
  challengeType?: string | null;
  targetValue?: number | null;
  targetUnit?: string | null;
  result?: string | null;
  challenger?: {name?: string | null} | null;
}

export type TomStatus = 'ativo' | 'espera' | 'encerrado';

// Espelha o ChallengeStatusEnum. `draft` fica de fora de proposito: e desafio
// que o proprio usuario ainda nao enviou e nao deveria aparecer como recebido.
const STATUS: Record<string, {label: string; tom: TomStatus}> = {
  pending: {label: 'Aguardando resposta', tom: 'espera'},
  scheduled: {label: 'Agendado', tom: 'espera'},
  active: {label: 'Em andamento', tom: 'ativo'},
  finished: {label: 'Finalizado', tom: 'encerrado'},
  rejected: {label: 'Recusado', tom: 'encerrado'},
  closed: {label: 'Encerrado', tom: 'encerrado'},
  draft: {label: 'Rascunho', tom: 'espera'},
};

export const statusDoDesafio = (valor?: string | null): {label: string; tom: TomStatus} =>
  STATUS[valor ?? ''] ?? {label: '', tom: 'espera'};

const TIPOS: Record<string, string> = {
  personal_record: 'Recorde',
  calories: 'Calorias',
  distance: 'Distância',
  time: 'Tempo',
  checkins: 'Check-ins',
};

export const tipoDoDesafio = (valor?: string | null): string => TIPOS[valor ?? ''] ?? '';

// targetValue e Float e targetUnit pode faltar; mostrar "50 " com espaco solto
// pareceria dado truncado.
export const metaDoDesafio = (desafio: Challenge): string => {
  if (typeof desafio.targetValue !== 'number') return '';

  const valor = desafio.targetValue.toLocaleString('pt-BR', {maximumFractionDigits: 2});
  const unidade = desafio.targetUnit?.trim();

  return unidade ? `${valor} ${unidade}` : valor;
};

export const tituloDoDesafio = (desafio: Challenge): string =>
  desafio.title?.trim() || tipoDoDesafio(desafio.challengeType) || 'Desafio';
